import { bodySchema } from './body.schema';
import { z } from 'zod/v4';

const baseSchema = z.object({
  type: z.string(),
  priority: z.number(),
});

const deleteFileSchema = baseSchema.extend({
  type: z.literal('DeleteFile'),
  body: bodySchema,
});

const downloadFileSchema = baseSchema.extend({
  type: z.literal('DownloadFile'),
  body: bodySchema,
});

const deleteFolderSchema = baseSchema.extend({
  type: z.literal('DeleteFolder'),
  body: bodySchema.extend({
    file: z.string().optional(), // 'file' is optional here
  }),
});

/* Based on the type, the schema will be inferred */
export const blockSchema = z.discriminatedUnion('type', [
  deleteFileSchema,
  downloadFileSchema,
  deleteFolderSchema,
]);

export type BlockGroup = z.infer<typeof blockSchema>;
